import React from "react";

const JobTwo = () => {
  return (
    <div>
      <div>
        <h2>What We Need</h2>
        <p className="what-we-need-paragraph">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </p>
      </div>
      <div>
        <h2>Responsibilities</h2>
        <p className="responsibiliity">
          - Responsibility <br></br>- Responsibility<br></br> - Responsibility
          <br></br> - Responsibility<br></br> - Responsibility
        </p>
      </div>
      <div>
        <h2>Requirements</h2>
        <p className="requirement">
          - Requirements <br></br>- Requirements<br></br> - Requirements
          <br></br> - Requirements<br></br> - Requirements
        </p>
      </div>
      <div>
        <h2>Application</h2>
        <p className="application">-Link to Google Form</p>
      </div>
    </div>
  );
};

export default JobTwo;
